/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';

interface Terms {
  termsAtclNm: string;
  termsCn: string;
}

interface Section1Props {
  data: Terms;
}

const Section1 = ({ data }: Section1Props) => {
  const { mq } = useTheme();

  const section1Style = css`
    padding-bottom: 170px;
    .container {
      max-width: 1200px;
      margin: 0 auto;
      .title {
        font-size: 48px;
        font-weight: 700;
        line-height: 68px;
        padding: 90px 0;
      }
    }
    ${mq.mobile} {
      .container {
        width: 100%;
        padding: 32px;
        .title {
          font-size: 32px;
          font-weight: 700;
          line-height: 48px;
          padding: 40px 0;
        }
      }
    }
  `;
  return (
    <div css={section1Style}>
      <div className="container">
        <div className="title">{data.termsAtclNm}</div>
        <div dangerouslySetInnerHTML={{ __html: data.termsCn }} />
      </div>
    </div>
  );
};

export default Section1;
